export default class RevisionAppointment {
  constructor({ id, status, message = "" }) {
    this.id = id;
    this.status = status;
    this.message = message;
  }
}
